import React, { useEffect, useRef, useState } from 'react';
import Hls from 'hls.js';
import { getBannerStreamUrl } from '../../Services/services';

export default function BannerVideoPreview({ bannerId, file, hlsUrl }) {
  const videoRef = useRef(null);
  const [localUrl, setLocalUrl] = useState('');
  const [error, setError] = useState('');
  const source = file ? localUrl : hlsUrl;

  useEffect(() => {
    if (!file) {
      setLocalUrl('');
      return;
    }
    const url = URL.createObjectURL(file);
    setLocalUrl(url);
    return () => URL.revokeObjectURL(url);
  }, [file]);

  useEffect(() => {
    const video = videoRef.current;
    if (!video || !source) return;
    let cancelled = false;
    let hls;
    setError('');
    const load = async () => {
      let playbackUrl = source;
      let auth = new URLSearchParams();
      if (!file && bannerId) {
        const response = await getBannerStreamUrl(bannerId);
        if (cancelled) return;
        const details = response.data.responseDetails || response.data.data;
        playbackUrl = details.videoUrl;
        auth = new URL(playbackUrl).searchParams;
        if (details.cookies) {
          auth.set('Policy', details.cookies['CloudFront-Policy']);
          auth.set('Signature', details.cookies['CloudFront-Signature']);
          auth.set('Key-Pair-Id', details.cookies['CloudFront-Key-Pair-Id']);
        }
      }
      const authorize = (url) => {
        const parsed = new URL(url, playbackUrl);
        if (parsed.origin === new URL(playbackUrl).origin) {
          auth.forEach((value, key) => parsed.searchParams.set(key, value));
        }
        return parsed.toString();
      };
      if (!file && /\.m3u8($|\?)/i.test(playbackUrl) && Hls.isSupported()) {
        hls = new Hls({
          xhrSetup: (xhr, url) => { xhr.open('GET', authorize(url), true); },
        });
        hls.loadSource(authorize(playbackUrl));
        hls.attachMedia(video);
      } else {
        video.src = file ? source : authorize(playbackUrl);
      }
    };
    load().catch(() => { if (!cancelled) setError('Video preview unavailable.'); });
    return () => { cancelled = true; hls?.destroy(); };
  }, [source, file, bannerId]);

  return source ? (
    <div>
      <video ref={videoRef} controls playsInline preload="metadata" aria-label="Banner video preview"
        style={{ width: '100%', maxHeight: 200, borderRadius: 8, background: '#000' }} />
      {error && <p className="text-danger small" role="alert">{error}</p>}
    </div>
  ) : null;
}
